import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { Box, Card, Link as MUILink, CardActions, CardContent, CardMedia, CircularProgress, Paper, Typography } from '@mui/material';
import Button from '../../../../components/Button.js';
import { Link } from 'react-router-dom';
import useFetch from '../../../../hooks/useFetch.js';
import { getAllV2Live } from '../../../../../api/index.js';
import { getUserProvider } from '../../../../../actions/auth.js';
import { getRootUrl } from '../../../../../api/infoEnv.js';
import LiveDTO from '../../../../DTO/LiveDTO.js';

const GetLives = () => {

    return <Box sx={{ textAlign : 'center'}}>
            <Button to="/multisport/events/lives/create" component={Link}>Créer un direct</Button>

            <br/>

            <Lives/>
    </Box>

}

const Lives = () => {

    const provider = getUserProvider()

    const { data, isLoading, error, fetchData } = useFetch(getAllV2Live, [provider]);

    useEffect(() => {
        fetchData()
    }, [])

    if(isLoading)
        return <CircularProgress sx={{mt : 3}}/>

    if(!data || data.length === 0)
        return <Typography sx={{m : 3}}>Aucun live</Typography>

    return <Box>
        {data && data.map(live => <Live live={new LiveDTO(live)}></Live>)}
    </Box>
}

const Live = ({live}) => {

    return (
        <Card sx={{ width: '300px', display: 'inline-block', m: 3, p: 1 }}>
          <CardMedia image={undefined} title="Direct" />
          <CardContent>
            <Typography variant="subtitle1" style={{fontWeight:'bolder'}} >{live.name}</Typography>
            <Typography variant="subtitle2">
              {format(new Date(live.date), "dd-MM-yyyy' 'HH'h'mm")}
            </Typography>
          </CardContent>
          <Box style={{padding:'1em'}}>
            <Button
                sx={{ m: 1 }}
                href={getRootUrl() + '/lives/' + live._id + '/calendar'}
                target="_blank"
                variant="contained"
            >
                Calendrier
            </Button>
            <Button
                sx={{ m: 1 }}
                href={getRootUrl() + '/lives/' + live._id + '/classement'}
                target="_blank"
                variant="contained"
            >
                Classement
            </Button>
            <Button
                sx={{ m: 1 }}
                href={getRootUrl() + '/lives/' + live._id + '/resultat'}
                target="_blank"
                variant="contained"
            >
                Résultat
            </Button>
            <Button  sx={{ m: 1 }} component={Link} to={"collect/" + live._id + "/calendar"}>
                Saisir des données
            </Button>
            </Box>
        </Card>
      );
}

export default GetLives